import { defineComponent as _defineComponent } from 'vue'
import Control from './control.vue'
import { showToolbox, DataSetAtom, TemploraryID, token } from '@/store'
import {
  list as ylist,
  uploadList,
  getSureAttachDatasets,
  storeSave,
  main,
  filePropress,
  cancelFileUpload,
  recovery
} from '@/store/dataset'
import TreeAtom from '@/components/tree-atom/index.vue'
import { icons } from '@/components/dataset-tree/constant'
import Info from '@/components/info/index.vue'
import { Dialog } from '@kankan/components'
import { router, writeRouteName } from '@/router'
import {
  genUseLoading,
  useDataset,
  useSDK,
  useViewStack,
  useConfirm
} from '@/hook'
import { Model } from '@/request'
import { computed, ref, watch, watchEffect } from 'vue'
import { asyncTimeout, formatDate } from '@/utils'
import { PropressProp } from '@/components/propress/help'
import FlotPropress from '@/components/propress/index.vue'
import { jobStatus, JOBEUM } from '@/store/setup'
import { ui18n } from '@/lang'
import { onMounted } from 'vue'
import { showHotImage } from '@/store/setting'
import { closeCurrentHotImage } from '@/hook/useShadre'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const list = computed(() => ylist.value.concat(uploadList.value))
const vm = ref()

const inDisabled = (item: DataSetAtom) =>
  TemploraryID.is(item.id) || !!item.jobId

const flyDataset = (atom: DataSetAtom) => {
  useDataset(atom).flyTo()
}

const getDatasetFormats = (dataset: DataSetAtom) => {
  const formats = []
  const supper = {
    lasExist: '.las',
    plyExist: '.ply',
    objExist: '.obj',
    e57Exist: '.e57'
  }
  for (const [key, val] of Object.entries(supper)) {
    if (dataset[key]) {
      formats.push(val)
    }
  }
  return formats
}

const delAttach = async (atom: DataSetAtom) => {
  if (await useConfirm(ui18n.t('dataset.deleteTip'))) {
    const index = list.value.indexOf(atom)
    if (~index) {
      ylist.value.splice(index, 1)
      save()
    }
  }
}

const refreshHandler = async () => {
  if (
    await useConfirm({
      title: ui18n.t('dataset.reset.title'),
      content: ui18n.t('dataset.reset.tip')
    })
  ) {
    uploadList.value = []
    ylist.value = [main.value]
    save()
  }
}
const genTempDataset = (id, title, name, attachId?: string): DataSetAtom => ({
  id: TemploraryID.get(),
  title,
  time: Date.now(),
  orientation: -1,
  e57Exist: false,
  from: '',
  color: '#d50000',
  floorPanType: null,
  plyExist: false,
  gfw: true,
  location: [0, 0, 0],
  sceneVersion: 'V4',
  lasExist: false,
  objExist: false,
  attachId: attachId,
  isCalibrated: true,
  version: -1,
  isItself: false,
  shootTime: formatDate(new Date(), 'yyyy-mm-dd hh:MM'),
  pointCount: 0,
  sceneName: name,
  status: 0,
  has_panos: false
})

const selectHandler = async (data: Model.SureDataset) => {
  const temp = genTempDataset(
    TemploraryID.get(),
    data.sceneCode,
    data.name,
    data.datasetId
  )
  uploadList.value.push(temp)
  await save(false)
  jobStatus.value = JOBEUM.ADDSET
}

const propress = ref<PropressProp>()
const cancelHandler = () => {
  if (cancelFileUpload.value) {
    cancelFileUpload.value()
  }
  propress.value = null
}
const active = ref<DataSetAtom>()

// const scene = useSDK().scene
// const updateActive = () => {
//     const datasetId = scene.getPointByScreen()?.datasetId
//     if (datasetId) {
//         active.value = list.value.find(atom => atom.id === datasetId)
//     }
// }
// scene.on('posChange', updateActive)
// updateActive()

const uploadHandler = async (data: File) => {
  const dataset = genTempDataset(
    TemploraryID.get(),
    ui18n.t('dataset.uploadTitle'),
    ui18n.t('dataset.uploadTitle')
  )
  propress.value = {
    id: dataset.id,
    setp: 0,
    title: ui18n.t('dataset.uploadIng'),
    closeText: ui18n.t('sys.cancel')
  }
  const stop = watch(filePropress, async () => {
    if (propress.value && filePropress.value !== 100) {
      propress.value.setp = filePropress.value
    } else {
      if (filePropress.value && propress.value) {
        propress.value.setp = filePropress.value
        await asyncTimeout(16)
      }
      propress.value = null
      stop()
    }
  })

  dataset.file = data
  uploadList.value.push(dataset)
  try {
    await save(false)
    jobStatus.value = JOBEUM.ADDSET
  } catch {
    stop()
  }
}

const save = genUseLoading(async (autoReload = true) => {
  try {
    await storeSave()
    autoReload && location.reload()
    // await asyncTimeout(1000)
  } catch {
    recovery()
    throw new Error('用户已取消')
  }
})

closeCurrentHotImage()
useViewStack(() => {
  useSDK().enterDatasetsManage()
  return () => {
    useSDK().leaveDatasetsManage()
  }
})

const __returned__ = { list, vm, inDisabled, flyDataset, getDatasetFormats, delAttach, refreshHandler, genTempDataset, selectHandler, propress, cancelHandler, active, uploadHandler, save, Control, get main() { return main }, TreeAtom, get icons() { return icons }, Info, get router() { return router }, get writeRouteName() { return writeRouteName }, FlotPropress }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})